<template>
  <div id="app" class="app ods-grid">
    <template v-if="isAuthenticated">
      <ods-header
        :can-change-representation="canChangeRepresentation"
        :is-logged-in="true"
        :logo-link="environments.VUE_APP_STARTSIDEN_URL || '/'"
        :representing="getUserName"
        @logout="logout"
        @changeRepresentation="changeRepresentation()"
      />
      <div class="ods-grid ods-grid--gutter">
        <div class="ods-grid__column--12">
          <ods-back-link :href="getBacklink.href" :text="getBacklink.text" />
        </div>
        <div
          class="ods-grid__column--12 ods-grid--center ods-margin-vertical-8 ods-margin-vertical-13-breakpoint-medium"
        >
          <div class="ods-grid ods-grid--gap-row-large">
            <div class="ods-padding-3 ods-grid__column--12">
              <router-view
                class="ods-margin-top-5 ods-margin-bottom-19 ods-margin-top-13-breakpoint-medium ods-margin-bottom-25-breakpoint-medium"
              />
            </div>
          </div>
        </div>
      </div>
      <div id="announcer" class="sr-only" aria-live="polite" />
      <ods-footer :content-list="footerContent" />
    </template>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import OdsFooter from '@/global-components/OdsFooter.vue';
import OdsHeader from '@/global-components/OdsHeader.vue';
import OdsBackLink from '@/global-components/OdsBackLink.vue';

export default {
  name: 'App',

  components: {
    OdsBackLink,
    OdsFooter,
    OdsHeader,
  },

  props: {
    logout: {
      type: Function,
      required: true,
    },
    updateToken: {
      type: Function,
      required: true,
    },
  },

  data: () => ({
    footerContent: [
      {
        header: 'Kontakt',
        links: [{ text: 'Kontakt Oslo kommune', href: 'https://www.oslo.kommune.no/kontakt/' }],
      },
      {
        header: 'Om nettstedet',
        links: [
          {
            text: 'Personvern og informasjonskapsler',
            href: 'https://www.oslo.kommune.no/personvern-og-informasjonskapsler/',
          },
        ],
      },
    ],
  }),

  computed: {
    ...mapGetters(['getBacklink']),
    ...mapGetters('representasjoner', ['getOrgsToRepresent', 'getCurrentRepresentation']),
    ...mapState(['brukerinfo', 'isAuthenticated', 'environments']),
    getUserName() {
      return this.representatingOrg
        ? this.$minside.formatCompanyName(this.getCurrentRepresentation.navn)
        : `${this.brukerinfo.fornavn} ${this.brukerinfo.etternavn}`;
    },
    canChangeRepresentation() {
      return this.$route.name === 'SelectRepresentation' ? false : this.getOrgsToRepresent.length > 0;
    },
    representatingOrg() {
      return (
        this.getCurrentRepresentation &&
        this.getCurrentRepresentation.identifikator &&
        !this.getCurrentRepresentation.erPrivatPerson
      );
    },
  },

  created() {
    this.setKeycloakUpdateToken(this.updateToken);
  },

  methods: {
    ...mapActions(['setKeycloakUpdateToken']),
    changeRepresentation() {
      this.$router.push({ name: 'SelectRepresentation' });
    },
  },
};
</script>

<style lang="scss">
@use 'sass:map';
@import 'https://oslokommune-designsystem.s3.dualstack.eu-central-1.amazonaws.com/3.1.0/ods.css';

.app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.ods-main {
  flex-grow: 1;
}
</style>
